<template>
    <section>
        <div class="t-headline5 mt3">
            {{$t('1530')}}
            <!-- 회원 유형 선택 -->
        </div>
        <div class="t-body3 mt6 t-color-bodyGrayA">
            {{$t('1531')}}
            <!-- 가입하실 회원유형을 선택하세요. -->
        </div>
        <div class="mt88">
            <div class="mt30" v-for="role in roleList" :key="role.value">
                
                <div class="mdc-form-field">
                    <div class="mdc-radio radio-red">
                        <input class="mdc-radio__native-control" type="radio" 
                            :value="role.value" 
                            :id="'roleRadio'+role.value"
                            v-model="selectedRole"
                        >
                        <div class="mdc-radio__background">
                            <div class="mdc-radio__outer-circle"></div>
                            <div class="mdc-radio__inner-circle"></div>
                        </div>
                    </div>
                    <label :for="'roleRadio'+role.value">
                        {{$t(role.text)}}
                        <!-- {{role.text}} -->
                    </label>
                </div>
            </div>
            
        </div>
        <div class="mt64">
            <button class="mdc-button mdc-button--raised btn-red mr8" @click="next()" @keypress="next()" tabindex="0">
                {{$t('1532')}}
                <!-- 다음 -->
            </button>
            <button class="mdc-button btn-white t-color-secondaryBtnText" @click="cancelJoin()"  @keypress="cancelJoin()" type="button" tabindex="0">
                {{$t('1533')}}
                <!-- 취소 -->
            </button>
        </div>

        
        
    </section>
</template>

<script>
/**
 * 비밀번호 찾기 Step1 컴포넌트
 *
 * @author minkyoung.park@emcast.com
 * @author 
 * @since 2019.04
 */

// MDC Components 선언 S
import {MDCFormField} from '@material/form-field'
import {MDCRadio} from '@material/radio'
import {MDCRipple} from '@material/ripple'

// API 임포트
import joinApi from '@/api/joinApi.js'

// Store 임포트
import {mapState, mapMutations} from 'vuex'

import {joinMixin} from '@/mixins/join.js'
import { log } from 'util';

export default {
    data() {
        return {
            roleList: null,
            selectedRole: null,
            authWayResponse: null,
        }
    },

    mixins: [joinMixin],
    created() {
        // 접근 유효성 체크
        if (this.$route.query.type === 'social') {
            if (!this.join.socialId || !this.join.socialLink.token || !this.join.socialLink.type) {
                this.$router.go(-1)
            }
        }
    },

    mounted() {
        this.setMaterialUi()
        this.fetchData()
        this.selectedRole = this.join.role
    },
    computed: {
        ...mapState('join',{
            join : state => state,
        })
    },

    methods: {
        ...mapMutations('join', ['SET_ROLE']),

        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },

        fetchData() {
            joinApi.role().then((response) => {
                this.roleList = response.data.data        
            }).catch((err) => {})
        },

        // 인증수단 조회 API 호출
        next() {
            if (this.selectedRole) {
                this.SET_ROLE(this.selectedRole)

                joinApi.authWay().then((response) => {
                    this.authWayResponse = response.data.data
                    if (this.authWayResponse.usage) {
                        this.$router.push({name: 'JoinCode', query: this.$route.query})
                    }else {
                        this.$router.push({name: 'JoinResponsibility', query: this.$route.query})
                    }
                }).catch((err) => {

                })
            }else {
                this.$snackOpen({
                    // contents:'회원유형을 선택해주세요.'
                    contents: this.$t('50000'),
                    btnDisplay: ''
                    
                }).then(() => {})
            }
        },

        
        
    }
}
</script>

<style>

</style>
